import React, {
  useState,
  useEffect,
  // useRef,
  useMemo,
  useCallback,
} from 'react';
// import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Theme,
  Grid,
  Card,
  CardContent,
  CardActions,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Tooltip, // 추가
  Chip, // 추가
  alpha,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import { fetchApi } from '../services/api';
import { format } from 'date-fns';
import SideMenu from '../components/SideMenu';
import SearchLayer from '../components/SearchLayer';
import AlertSnackbar from '../components/AlertSnackbar';
import SearchIcon from '@mui/icons-material/Search';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CloseIcon from '@mui/icons-material/Close';
import AutoCompleteSearch from '../components/AutoCompleteSearch';
import ItineraryDialog from '../components/ItineraryDialog';

interface ApiTableResponse {
  table: Itinerary[];
}

interface LandInfo {
  사업자등록번호유무: boolean;
  사업자등록번호: string;
  대표자: string;
  대표전화: string;
  대표이메일: string;
  우편번호: string;
  기본주소: string;
  상세주소: string;
  업체번호: number;
  업체명: string;
  통신판매업신고번호: string;
  관광사업자번호: string;
  영업보증보험료: number;
  기획여행보증보험료: number;
  회사로고: string;
}
type Itinerary = {
  일정번호: number;
  일정명: string;
  상품가: number;
  유저명: string;
  업체명: string;
  등록일시: string;
  공유: boolean;
  조회수: number;
  공유수: number;
  엑셀파일경로: string;
  방문도시?: string;
  내용?: string;
  즐겨찾기?: boolean;
  원본일정번호?: number;
  업체번호: string;
  출발시간: string;
  도착시간: string;
  출발월: string;

} & {
  [key: string]: string | number | boolean;
};

const drawerWidth = 240;

const ItinerarySharePage: React.FC = () => {
  const [itineraries, setItineraries] = useState<Itinerary[]>([]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [popupContent, setPopupContent] = useState<Itinerary | null>(null);

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: 'asc' | 'desc' | null;
  }>({
    key: '',
    direction: null,
  });

  const [searchValues, setSearchValues] = useState<{
    국가번호: number | undefined;
    도시번호: number | undefined;
    업체번호: number | undefined;
  }>(() => {
    const saved = localStorage.getItem('itinerarySearchValues');
    return saved
      ? JSON.parse(saved)
      : {
        국가번호: undefined,
        도시번호: undefined,
        업체번호: undefined,
      };
  });

  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [companyInfoDialog, setCompanyInfoDialog] = useState(false);
  const [companyInfoData, setCompanyInfoData] = useState<LandInfo | null>(null);
  const [companyIntroduction, setCompanyIntroduction] = useState<string>('');

  const [shareConfirmDialog, setShareConfirmDialog] = useState(false);
  const [selectedShareItinerary, setSelectedShareItinerary] = useState<Itinerary | null>(null);

  const [newsItems, setNewsItems] = useState<Array<{ title: string; pubDate: string; link: string }>>([]);
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);

  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(
          'https://api.allorigins.win/raw?url=' + encodeURIComponent('https://www.traveltimes.co.kr/rss/allArticle.xml')
        );
        const xmlText = await response.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
        const items = xmlDoc.querySelectorAll('item');
        const newsData = Array.from(items).map((item) => ({
          title: item.querySelector('title')?.textContent || '',
          pubDate: item.querySelector('pubDate')?.textContent || '',
          link: item.querySelector('link')?.textContent || '',
        }));
        setNewsItems(newsData);
      } catch (error) {
        console.error('뉴스 로딩 실패:', error);
      }
    };

    fetchNews();
  }, []);

  useEffect(() => {
    if (newsItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrentNewsIndex((prev) => (prev + 1) % newsItems.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [newsItems]);

  const handleLandInfo = async (itinerary: Itinerary) => {

    const postData = [{ 컬럼명: '@업체번호', 값: itinerary.업체번호 }];
    const response = await fetchApi<any>('ITN_S_업체세부정보', postData);
    if (response?.data?.table?.[0]) {
      setCompanyInfoData(response.data.table[0]);
      setCompanyIntroduction(response.data.table[0].회사소개);
      setCompanyInfoDialog(true);
    }
  };
  const handleCloseCompanyInfoDialog = () => {
    setCompanyInfoDialog(false);
    setCompanyInfoData(null);
  };

  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
  }>({
    open: false,
    message: '',
    severity: 'info',
  });

  const fetchItineraries = React.useCallback(
    async (searchValues: {
      국가번호: number | undefined;
      도시번호: number | undefined;
      업체번호: number | undefined;
    }) => {
      try {
        const CompanyNo = localStorage.getItem('CompanyNo');
        const postData = [
          { 컬럼명: '@국가번호', 값: searchValues.국가번호?.toString() || '0' },
          { 컬럼명: '@도시번호', 값: searchValues.도시번호?.toString() || '0' },
          { 컬럼명: '@업체번호', 값: searchValues.업체번호?.toString() || '0' },
          { 컬럼명: '@내업체번호', 값: CompanyNo },
        ];

        const response = await fetchApi<ApiTableResponse>('ITN_S_일정공유', postData);
        if (response?.data?.table) {
          // null 체크: 모든 필드가 null인 데이터는 필터링
          const validItineraries = response.data.table.filter((itinerary) =>
            Object.values(itinerary).some((value) => value !== null)
          );
          if (validItineraries.length === 0) {
            setSnackbar({
              open: true,
              message: '검색 결과가 없습니다.',
              severity: 'info',
            });
          }

          setItineraries(validItineraries);
        } else {
          setItineraries([]);
        }
      } catch (error) {
        console.error('Failed to fetch itineraries:', error);
      }
    },
    []
  ); // 의존성 배열 비움

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClose = () => setOpen(false);

  const handleSearch = useCallback(
    async (searchValues: {
      국가번호: number | undefined;
      도시번호: number | undefined;
      업체번호: number | undefined;
    }) => {
      setIsSelectOpen(false);
      setSearchValues(searchValues);
      const subtitleElement = document.querySelector('.subtitle');
      if (subtitleElement) {
        (subtitleElement as HTMLElement).style.color = 'white';
      }
    },
    []
  );
  const handleAutoCompleteSearch = (업체번호?: number, 도시번호?: number) => {
    const searchValues = {
      국가번호: 0,
      도시번호: 도시번호,
      업체번호: 업체번호,
    };
    setSearchValues(searchValues);
  };
  const handleNewOpen = async (itinerary: Itinerary) => {
    const previewUrl = `${window.location.origin}/preview/${itinerary.일정번호}`;
    window.open(previewUrl, '_blank');
  };

  const handleOpen = async (itinerary: Itinerary) => {
    try {
      const postData = [
        { 컬럼명: '@일정번호', 값: itinerary.일정번호.toString() },
        { 컬럼명: '@공유여부', 값: 0 }, // NOT NULL 일때 조회수 + 1
      ];

      const response = await fetchApi<ApiTableResponse>('ITN_S_일정표', postData);

      if (response.data && response.data.table) {
        setPopupContent(response.data.table[0]);
      }

      setOpen(true);
    } catch (error) {
      console.error('Failed to fetch itinerary detail:', error);
      setPopupContent(itinerary);
      setOpen(true);
    }
  };

  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'yyyy-MM-dd');
    } catch {
      return dateString;
    }
  };

  const handleShareClick = async (itinerary: Itinerary) => {
    setSelectedShareItinerary(itinerary);
    setShareConfirmDialog(true);
  };

  const handleConfirmShare = async () => {
    if (!selectedShareItinerary) return;

    try {
      const postData = [
        { 컬럼명: '@업체번호', 값: localStorage.getItem('CompanyNo') },
        { 컬럼명: '@일정번호', 값: selectedShareItinerary.일정번호 },
        { 컬럼명: '@유저번호', 값: localStorage.getItem('UserNo') },
      ];

      const response = await fetchApi<ApiTableResponse>('ITN_T_간편일정공유', postData);

      if (response.data) {
        setSnackbar({
          open: true,
          message: '내 일정표에 추가되었습니다.',
          severity: 'success',
        });
        handleSearch(searchValues);
      } else {
        setSnackbar({
          open: true,
          message: '일정 공유에 실패했습니다.',
          severity: 'error',
        });
      }
    } catch (error) {
      console.error('Failed to share itinerary:', error);
      setSnackbar({
        open: true,
        message: '일정 공유 중 오류가 발생했습니다.',
        severity: 'error',
      });
    } finally {
      setShareConfirmDialog(false);
      setSelectedShareItinerary(null);
    }
  };

  const handleCancelShare = () => {
    setShareConfirmDialog(false);
    setSelectedShareItinerary(null);
  };

  const handleSort = (key: string) => {
    let sortKey = key;
    if (key === '등록업체') {
      sortKey = '업체명';
    }

    setSortConfig((prevConfig) => ({
      key: sortKey,
      direction:
        prevConfig.key === sortKey
          ? prevConfig.direction === 'asc'
            ? 'desc'
            : prevConfig.direction === 'desc'
              ? null
              : 'asc'
          : 'asc',
    }));
  };

  const sortedItineraries = useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return itineraries;

    return [...itineraries].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (sortConfig.key === '상품가' || sortConfig.key === '조회수' || sortConfig.key === '공유수') {
        return sortConfig.direction === 'asc' ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue);
      }

      if (sortConfig.key === '등록일시') {
        return sortConfig.direction === 'asc'
          ? new Date(aValue as string).getTime() - new Date(bValue as string).getTime()
          : new Date(bValue as string).getTime() - new Date(aValue as string).getTime();
      }

      if (typeof aValue === 'boolean') {
        return sortConfig.direction === 'asc' ? (aValue ? 1 : -1) : aValue ? -1 : 1;
      }

      return sortConfig.direction === 'asc'
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }, [itineraries, sortConfig]);

  const filteredItineraries = useMemo(() => {
    if (!searchTerm) return sortedItineraries;

    return sortedItineraries.filter((itinerary) => {
      const searchLower = searchTerm.toLowerCase();
      // 모든 필드를 검색
      return Object.values(itinerary).some((value) => String(value).toLowerCase().includes(searchLower));
    });
  }, [sortedItineraries, searchTerm]);

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  // Utility function to truncate text in the middle with ellipsis
  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    const half = Math.floor(maxLength / 2);
    return text.slice(0, half) + '...' + text.slice(-half);
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const isInitialSearch = () => {
    return (
      searchValues.국가번호 === undefined && searchValues.도시번호 === undefined && searchValues.업체번호 === undefined
    );
  };

  useEffect(() => {
    localStorage.setItem('itinerarySearchValues', JSON.stringify(searchValues));
    if (!isInitialSearch()) {
      fetchItineraries(searchValues);
    }
  }, [searchValues, fetchItineraries]);

  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          p: 0,
        }}>
        <Box sx={{ flex: 1 }}>
          <Paper
            elevation={0}
            sx={{
              ...(isMobile ? { p: 1.5, mt: 6 } : { p: 1.5, m: 1.5, mt: 0 }),
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              height: '62px',
            }}>
            <Box
              sx={{
                mb: 0,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <ShareIcon sx={{ mr: 1 }} />
                <Typography variant="h6">일정 플랫폼</Typography>
              </Box>
              {!isMobile && (
                <Paper
                  elevation={0}
                  sx={{
                    ml: 2,
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    // boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    padding: '12px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    width: '700px',
                    overflow: 'hidden',
                    position: 'relative',
                  }}>
                  <img
                    src="https://kr.object.iwinv.kr/etc/traveltimes.png"
                    alt="Travel Times"
                    style={{
                      height: '16px',
                      marginRight: '16px',
                    }}
                  />
                  <Typography
                    variant="body2"
                    component="a"
                    href={newsItems[currentNewsIndex]?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: '#666',
                      flex: 1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontSize: '14px', // Adjust the font size as needed, e.g., '0.9rem',
                      textDecoration: 'none',
                      '&:hover': {
                        color: 'primary.main',
                        textDecoration: 'underline',
                      },
                    }}>
                    {newsItems[currentNewsIndex]?.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#666',
                      ml: 2,
                      whiteSpace: 'nowrap',
                      fontSize: '0.9rem',
                    }}>
                    {new Date(newsItems[currentNewsIndex]?.pubDate).toLocaleDateString('ko-KR')}
                  </Typography>
                </Paper>
              )}
              {/* <AutoCompleteSearch onSearch={handleAutoCompleteSearch} /> */}
              <FormControl
                size="small"
                sx={{
                  minWidth: 120,
                  '& .MuiOutlinedInput-root': {
                    height: '42px',
                    borderRadius: '8px',
                    backgroundColor: '#ffffff',
                    '&:hover': {
                      backgroundColor: 'fafafa',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e0e0e0',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  },
                  '& .MuiSelect-select': {
                    fontSize: '14px',
                    fontWeight: 500,
                    paddingLeft: '12px',
                  },
                }}>
                <SearchLayer
                  isSelectOpen={isSelectOpen}
                  setIsSelectOpen={setIsSelectOpen}
                  handleSearchProp={(국가번호, 도시번호, 업체번호) => {
                    handleSearch({
                      국가번호: 국가번호,
                      도시번호: 도시번호,
                      업체번호: 업체번호,
                    });
                  }}
                />
              </FormControl>
            </Box>
          </Paper>

          {isMobile ? (
            <Box>
              {filteredItineraries.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '300px',
                    width: '100%',
                    textAlign: 'center',
                    color: 'text.secondary',
                    p: 5,
                  }}>
                  <Typography variant="body1">
                    <SearchIcon sx={{ fontSize: '68px', color: '#ccc' }} />
                    <br />
                    <br />
                    <span
                      style={{
                        fontSize: '18px',
                        fontWeight: 900,
                        color: 'text.secondary',
                      }}>
                      여행 검색을 시작해보세요!{' '}
                    </span>
                    <br />
                    <br />
                    <br />
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'text.secondary',
                      }}>
                      우측 상단에서 국가/도시/업체를 선택하시면
                      <br />
                      다양한 여행 일정표를 확인하실 수 있습니다.
                    </span>
                    <br />
                    <br />
                    <br />
                  </Typography>
                </Box>
              ) : (
                <Grid container spacing={1} sx={{ mt: 0.1 }}>
                  {filteredItineraries.map((itinerary: Itinerary, index: number) => (
                    <Grid item xs={12} sm={6} md={4} key={itinerary.일정번호}>
                      <Card
                        sx={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        }}>
                        <Box onClick={() => handleOpen(itinerary)} sx={{ position: 'relative', p: 2, pb: 1 }}>
                          <Typography
                            variant="h6"

                            /*component="div"*/

                            sx={{
                              fontWeight: 600,
                              fontSize: '1.0rem',
                              color: '#1a1a1a',
                              mb: 1,
                            }}>
                            {itinerary.일정명}
                          </Typography>

                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 1,
                            }}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                              }}>
                              {/* <LocationOnOutlined sx={{ fontSize: '0.9rem', color: 'grey.600' }} /> */}
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.5,
                                  fontSize: '0.9rem',
                                }}>
                                {(itinerary.방문도시 as string)
                                  .split(',')
                                  .map((city: string, index: number, array: string[]) => {
                                    if (index < 4 || (index === 4 && array.length <= 5)) {
                                      return (
                                        <Box
                                          key={index}
                                          sx={{
                                            border: '1px solid #e0e0e0',
                                            padding: '4px 6px',
                                            borderRadius: '4px',
                                            fontSize: '13px',
                                            height: '24px',
                                            backgroundColor: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}>
                                          {city.trim()}
                                        </Box>
                                      );
                                    } else if (index === 4) {
                                      const remainingCount = array.length - 4;
                                      return (
                                        <Box
                                          key={index}
                                          sx={{
                                            border: '1px solid',
                                            padding: '4px 6px',
                                            borderRadius: '4px',
                                            fontSize: '13px',
                                            height: '24px',
                                            color: 'primary.main',
                                            borderColor: 'primary.main',
                                            backgroundColor: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}>
                                          +{remainingCount}
                                        </Box>
                                      );
                                    }
                                    return null;
                                  })}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                              }}>
                              {/* <PaidOutlined sx={{ fontSize: '0.9rem', color: 'grey.600' }} /> */}
                              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                                {itinerary.상품가}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        <CardActions
                          sx={{
                            mt: 'auto',
                            p: 2,
                            pt: 1,
                            display: 'flex',
                            gap: 1,
                            flexWrap: 'nowrap',
                            borderTop: '1px solid',
                            borderColor: 'grey.100',
                            overflowX: 'auto',
                          }}>
                          <IconButton
                            size="small"
                            onClick={() => handleNewOpen(itinerary)}
                            sx={{
                              color: 'primary.main',
                              backgroundColor: 'white',
                            }}>
                            <ListAltOutlinedIcon color="primary" sx={{ fontSize: '24px' }} />
                          </IconButton>
                          <IconButton
                            onClick={() => handleShareClick(itinerary)}
                            size="small"
                            sx={{ height: '36px', backgroundColor: 'white' }}>
                            <FileDownloadIcon color="primary" sx={{ fontSize: '24px' }} />
                          </IconButton>
                          <Box
                            onClick={() => handleLandInfo(itinerary)}
                            sx={{
                              pr: 1,
                              textAlign: 'right',
                              width: '100%',
                              fontSize: '14px',
                              color: 'primary.main',
                              cursor: 'pointer',
                              '&:hover': {
                                textDecoration: 'underline',
                              },
                            }}>
                            {itinerary.업체명}
                          </Box>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          ) : (
            <Paper
              elevation={1}
              sx={{
                p: 1.5,
                m: 1.5,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                minHeight: 'calc(100vh - 88px)',
              }}>
              <TableContainer component={Paper} elevation={0} sx={{ minHeight: 80 }}>
                {isInitialSearch() ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '300px',
                      width: '100%',
                      textAlign: 'center',
                      color: 'text.secondary',
                      p: 20,
                    }}>
                    <Typography variant="body1">
                      <SearchIcon sx={{ fontSize: '128px', color: '#ccc' }} />
                      <br />
                      <br />
                      <span
                        style={{
                          fontSize: '28px',
                          fontWeight: 900,
                          color: 'text.secondary',
                        }}>
                        여행 검색을 시작해보세요!{' '}
                      </span>
                      <br />
                      <br />
                      <br />
                      <span
                        style={{
                          fontSize: '18px',
                          fontWeight: 500,
                          color: 'text.secondary',
                        }}>
                        우측 상단에서 국가/도시/업체를 선택하시면
                        <br />
                        다양한 여행 일정표를 확인하실 수 있습니다.
                      </span>
                      <br />
                      <br />
                      <br />
                    </Typography>
                  </Box>
                ) : (
                  <Table
                    size="small"
                    aria-label="공유 일정 목록"
                    sx={{
                      tableLayout: 'fixed',
                      width: '100%',
                      '& .MuiTableCell-root': {
                        padding: '5px',
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      },
                    }}>
                    <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          cursor: 'pointer',
                          width: '30% !important',
                          // display: "flex",
                          // alignItems: "center",
                        }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                          <span onClick={() => handleSort('일정명')}>
                            일정명{' '}
                            {sortConfig.key === '일정명' &&
                              (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                          </span>
                          <TextField
                            size="small"
                            placeholder="필터 검색어를 입력하세요"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{
                              ml: 2,
                              '& .MuiOutlinedInput-root': {
                                height: '32px',
                                fontSize: '14px',
                                backgroundColor: 'white',
                                width: '200px',
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '430px' }} className="cities hidden-info">
                        방문도시{' '}
                        {sortConfig.key === '방문도시' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '11%' }}
                        className="hidden-info"
                        onClick={() => handleSort('상품가')}>
                        상품가{' '}
                        {sortConfig.key === '상품가' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '11%' }}
                        className="hidden-info"
                        onClick={() => handleSort('출발월')}>
                        출발월{' '}
                        {sortConfig.key === '출발월' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '5%' }}
                        className="hidden-info"
                        onClick={() => handleSort('출발시간')}>
                        출발시간{' '}
                        {sortConfig.key === '출발시간' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '5%' }}
                        className="hidden-info"
                        onClick={() => handleSort('도착시간')}>
                        도착시간{' '}
                        {sortConfig.key === '도착시간' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '10%' }}
                        className="hidden-info"
                        onClick={() => handleSort('등록업체')}>
                        등록업체{' '}
                        {sortConfig.key === '업체명' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '8%' }}
                        className="hidden-info"
                        onClick={() => handleSort('등록일시')}>
                        등록일시{' '}
                        {sortConfig.key === '등록일시' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '5%' }}
                        className="hidden-info"
                        onClick={() => handleSort('조회수')}>
                        조회수{' '}
                        {sortConfig.key === '조회수' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell
                        sx={{ cursor: 'pointer', width: '5%' }}
                        className="hidden-info"
                        onClick={() => handleSort('공유수')}>
                        공유수{' '}
                        {sortConfig.key === '공유수' &&
                          (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredItineraries.map((itinerary: Itinerary, index: number) => (
                        <TableRow
                          key={itinerary.일정번호}
                          hover
                          sx={{
                            height: '52px',
                            position: 'relative',
                            '&:hover': {
                              backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                              outline: (theme) => `1px solid ${theme.palette.primary.main}`,
                              '& .MuiTableCell-root': {
                                backgroundColor: 'transparent',
                                color: 'inherit',
                              },
                              '& .MuiIconButton-root': {
                                backgroundColor: 'white',
                                '&:hover': {
                                  backgroundColor: 'grey.100',
                                },
                              },
                              '& .hidden-info': {
                                color: 'transparent',
                                '& > *': {
                                  visibility: 'hidden',
                                },
                              },
                              '& .management-icons': {
                                display: 'flex',
                                visibility: 'visible',
                                height: '52px',
                                gap: '16px',
                              },
                              '& .cities': {
                                display: 'none',
                              },
                            },
                            '& .management-icons': {
                              display: 'none',
                              visibility: 'hidden',
                            },
                          }}>
                          <TableCell onClick={() => handleOpen(itinerary)} sx={{ cursor: 'pointer', color: 'primary.main' }}>
                            {itinerary.일정명}
                          </TableCell>
                          <TableCell
                            sx={{
                              display: 'flex',
                              gap: '5px',
                              height: '44px',
                              mt: '8px',
                            }}
                            className="cities hidden-info">
                            <Box
                              sx={{
                                display: 'flex',
                                minWidth: 400,
                                gap: '6px',
                                flexWrap: 'nowrap',
                                overflow: 'hidden',
                              }}>
                              {(itinerary.방문도시 as string)
                                .split(',')
                                .map((city: string, index: number, array: string[]) => {
                                  if (index < 4 || (index === 4 && array.length <= 5)) {
                                    return (
                                      <Box
                                        key={index}
                                        sx={{
                                          border: '1px solid #e0e0e0',
                                          padding: '4px 6px',
                                          borderRadius: '4px',
                                          fontSize: '13px',
                                          height: '24px',
                                          backgroundColor: 'white',
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}>
                                        {city.trim()}
                                      </Box>
                                    );
                                  } else if (index === 4) {
                                    const remainingCount = array.length - 4;
                                    return (
                                      <Box
                                        key={index}
                                        sx={{
                                          border: '1px solid',
                                          padding: '4px 6px',
                                          borderRadius: '4px',
                                          fontSize: '13px',
                                          height: '24px',
                                          color: 'primary.main',
                                          borderColor: 'primary.main',
                                          backgroundColor: 'white',
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}>
                                        +{remainingCount}
                                      </Box>
                                    );
                                  }
                                  return null;
                                })}
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              ml: 1,
                              display: 'flex',
                              justifyContent: 'left',
                              alignItems: 'center',
                              gap: '16px',
                            }}
                            className="management-icons">
                            <Tooltip title="일정표보기" leaveDelay={0} disableInteractive>
                              <IconButton
                                size="small"
                                onClick={() => handleNewOpen(itinerary)}
                                sx={{
                                  height: '41px',
                                  width: '41px',
                                  backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  },
                                }}>
                                <ListAltOutlinedIcon color="primary" sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="일정표 가져오기" leaveDelay={0} disableInteractive>
                              <IconButton
                                onClick={() => handleShareClick(itinerary)}
                                size="small"
                                sx={{
                                  height: '41px',
                                  width: '41px',
                                  backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  },
                                }}>
                                <FileDownloadIcon color="primary" sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>{truncateText(itinerary.상품가.toString(), 20)}</TableCell>
                          <TableCell className="hidden-info1">
                            {itinerary.출발월 && truncateText(itinerary.출발월.toString(), 20)}
                          </TableCell>
                          <TableCell className="hidden-info1">
                            {itinerary.출발시간 && truncateText(itinerary.출발시간.toString(), 20)}
                          </TableCell>
                          <TableCell className="hidden-info1">
                            {itinerary.도착시간 && truncateText(itinerary.도착시간.toString(), 20)}
                          </TableCell>
                          <TableCell>
                            <Box
                              onClick={() => handleLandInfo(itinerary)}
                              sx={{
                                pr: 1,
                                textAlign: 'left',
                                width: '100%',
                                fontSize: '14px',
                                color: 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline',
                                },
                              }}>
                              {itinerary.업체명}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{formatDate(itinerary.등록일시)}</TableCell>
                          {/* <TableCell sx={{ textAlign: 'center' }} >{itinerary.공유 && (<ShareOutlinedIcon color="primary" sx={{ fontSize: '18px' }} />)}</TableCell> */}
                          <TableCell sx={{ textAlign: 'center' }}>{itinerary.조회수}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{itinerary.공유수}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            </Paper>
          )}

          <ItineraryDialog
            open={open}
            onClose={handleClose}
            itinerary={popupContent}
          />

          <Dialog open={companyInfoDialog} onClose={handleCloseCompanyInfoDialog} maxWidth="md" fullWidth>
            {companyInfoData && (
              <>
                <DialogTitle
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderBottom: '1px solid #e0e0e0',
                    px: 3,
                  }}>
                  <Typography variant="h6" sx={{ pl: 1 }}>
                    {companyInfoData.업체명}
                  </Typography>
                  <Button
                    onClick={handleCloseCompanyInfoDialog}
                    size="small"
                    sx={{
                      bgcolor: 'white',
                      color: 'primary.main',
                      '&:hover': {
                        backgroundColor: 'grey.100',
                      },
                      height: '28px',
                    }}
                    startIcon={<CloseIcon sx={{ color: 'primary.main' }} />}>
                    닫기
                  </Button>
                </DialogTitle>
                <DialogContent sx={{ p: 1 }}>
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                    }}>
                    <Box
                      sx={{
                        width: { xs: '100%', sm: '45%' },
                        mb: { xs: 2, sm: 0 },
                      }}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>대표자명</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표자}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>대표전화</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표전화}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>이메일</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표이메일}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>주소</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>
                                {companyInfoData.기본주소 + ' ' + companyInfoData.상세주소}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>영업보증보험료</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.영업보증보험료}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>기획여행보증보험료</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.기획여행보증보험료}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>통신판매업신고업</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.통신판매업신고번호}</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                              '&:hover': { bgcolor: 'grey.50' },
                            }}>
                            <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                              <Typography sx={{ fontSize: '14px' }}>관광사업자번호</Typography>
                            </Box>
                            <Box sx={{ width: '60%', p: 1.5 }}>
                              <Typography sx={{ fontSize: '14px' }}>{companyInfoData.관광사업자번호}</Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        width: { xs: '100%', sm: '55%' },
                        pl: { xs: 0, sm: 2 },
                      }}>
                      <Box
                        sx={{
                          height: '100%',
                          p: 2,
                          bgcolor: 'grey.50',
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor: 'grey.300',
                        }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 'bold', mb: 1 }}>회사소개</Typography>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            whiteSpace: 'pre-wrap',
                            overflowY: 'auto',
                            maxHeight: { xs: '200px', sm: 'calc(100% - 30px)' },
                          }}>
                          {companyIntroduction}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </DialogContent>
              </>
            )}
          </Dialog>

          {/* 다이얼로그들 */}
          <Dialog
            open={shareConfirmDialog}
            onClose={handleCancelShare}
            aria-labelledby="share-confirm-dialog"
            PaperProps={{
              sx: {
                width: '400px',
                borderRadius: '16px',
                bgcolor: '#2F3136',
                color: 'white',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
              },
            }}>
            <DialogContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: '18px',
                  fontWeight: 'medium',
                  mb: 3,
                }}>
                선택한 일정을 내 일정표에 추가하시겠습니까?
              </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={handleCancelShare}
                sx={{
                  borderRadius: '8px',
                  height: '42px',
                  px: 3,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}>
                취소
              </Button>
              <Button
                onClick={handleConfirmShare}
                variant="contained"
                sx={{
                  borderRadius: '8px',
                  height: '42px',
                  px: 3,
                  bgcolor: '#5865F2',
                  '&:hover': {
                    bgcolor: '#4752C4',
                  },
                }}>
                확인
              </Button>
            </DialogActions>
          </Dialog>
          <AlertSnackbar
            open={snackbar.open}
            message={snackbar.message}
            severity={snackbar.severity}
            onClose={handleSnackbarClose}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ItinerarySharePage;
